export default "__VITE_ASSET__F8HJowdc__"